var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogsicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6697",
    "data-name": "Path 6697",
    d: "M13,3a9,9,0,0,0-9,9H1l3.89,3.89.07.14L9,12H6a7.034,7.034,0,1,1,2.06,4.94L6.64,18.36A9,9,0,1,0,13,3ZM12,8v5l4.25,2.52.77-1.28L13.5,12.15V8Z",
    transform: "translate(-1 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogsicon);
export default __webpack_public_path__ + "static/media/logsicon.3ce0144ef516e0bb75f6b78b98e882de.svg";
export { ForwardRef as ReactComponent };